"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkProfile = void 0;
exports.networkProfile = {
    name: 'network',
    methods: ['addNetwork', 'detectNetwork', 'getEndpoint', 'getNetworkProvider', 'removeNetwork'],
    events: ['providerChanged']
};
//# sourceMappingURL=profile.js.map